/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
// Personal libs
import { LogEntry } from './logger.interface';
import { AbstractLogManager } from './abstract-logger-manager';
import { BusEventEnum } from '../../enum/bus/bus-events.enum';
import bus from '../eventbus.lib';

export class LogManager extends AbstractLogManager {
  registerConsoleLogger(): AbstractLogManager {
    if (this.consoleLoggerRegistered) return this;

    // Console entries
    this.onLogEntry((logEntry: LogEntry) => {
      bus.emit(BusEventEnum.LOGGER_DISPLAY_ENTRY, logEntry);

      this.displayConsoleLog(logEntry);
    });

    this.consoleLoggerRegistered = true;
    return this;
  }
}

/**
 * Main logger
 */
export const logger = new LogManager()
  .configure()
  .registerConsoleLogger()
  .getLogger();

/**
 * Logger used by the Service Worker
 */
export const swLogger = new LogManager()
  .configure({
    fromServiceWorker: true,
  })
  .registerConsoleLogger()
  .getLogger();
